import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { PrestadorPsmtMedicosPage, PrestadorPsmtMedicosParams, PrestadorPsmtPrestadoresClientesPage, PrestadorPsmtPrestadoresClientesParams } from '@/core/api/sicom-api/registro/prestador/prestador-psmt.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorPsmtService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.psmtPrestadoresClientes;
    readonly MEDICOS_PATH = SICOM_PATHS.registro.prestador.psmtMedicos;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listarPrestadoresClientes(params: PrestadorPsmtPrestadoresClientesParams, context?: HttpContext): Observable<PrestadorPsmtPrestadoresClientesPage> {
        const httpParams = new HttpParams()
            .set('id', String(params.id))
            .set('uf', params.uf)
            .set('situacaoPsmt', params.situacaoPsmt)
            .set('sortBy', params.sortBy)
            .set('direction', params.direction)
            .set('page', String(params.page))
            .set('size', String(params.size));

        return this.http.get<PrestadorPsmtPrestadoresClientesPage>(this.PATH, { params: httpParams, context });
    }

    listarMedicos(params: PrestadorPsmtMedicosParams, context?: HttpContext): Observable<PrestadorPsmtMedicosPage> {
        const httpParams = new HttpParams()
            .set('id', String(params.id))
            .set('uf', params.uf)
            .set('idPrestadorCliente', String(params.idPrestadorCliente))
            .set('ufPrestadorCliente', params.ufPrestadorCliente)
            .set('composicao', params.composicao)
            .set('sortBy', params.sortBy)
            .set('direction', params.direction)
            .set('page', String(params.page))
            .set('size', String(params.size));

        return this.http.get<PrestadorPsmtMedicosPage>(this.MEDICOS_PATH, { params: httpParams, context });
    }
}
